import MR from "audio-recorder-polyfill";

if (!window.MediaRecorder) {
    window.MediaRecorder = MR;
}   